module.exports = __webpack_public_path__ + "img/75671.d574d2e4.svg";